var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M6 2a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2       2 0 0 0 2-2V8l-6-6H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#81C784",
    d: "M20 8h-6V2l6 6z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "75%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fill: "white",
    fontSize: 5,
    fontFamily: "Arial",
    fontWeight: "bold"
  }, "PNG")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/Png.61c4dc0794ad779375f2f63086733db2.svg";
export { ForwardRef as ReactComponent };